async function getUserLikesCount() {
  const serverURL = process.env.REACT_APP_SERVER_URL;
  const url = `${serverURL}/api/likes/count`;

  const response = await fetch(url, { credentials: "include" });
  const result = await response.json();

  const userLikesCount = result.count;
  return userLikesCount;
}

export default getUserLikesCount;
